module.exports = __webpack_public_path__ + "static/footer-about-bg-right-1c76a63de7fe3c33ad1189bb825ac1d7.jpg";